import { startOfDay } from 'date-fns';

import some from 'lodash/some';

import { getDateAsUTC } from './dateUtils';
import {
  dateIsBetween,
  getDaysDiff,
  dateIsEqualOrBefore,
  dateIsEqualOrAfter
} from './DateRangeHandler';

const MIN_STAY_INCLUSIVE_DAY = 1;

export const isMinStayValid = (moveIn, moveOut, minStay) =>
  getDaysDiff(moveIn, moveOut) >= minStay - MIN_STAY_INCLUSIVE_DAY;

export const isMaxStayValid = (moveIn, moveOut, maxStay) =>
  maxStay === null ? true : getDaysDiff(moveIn, moveOut) <= maxStay;

export const isMoveInDateValid = (moveIn, moveInDatesRanges) => {
  const moveInDate = getDateAsUTC(moveIn);

  return some(moveInDatesRanges, range => {
    const rFrom = range.from ? getDateAsUTC(range.from) : null;
    const rTo = range.to ? getDateAsUTC(range.to) : null;

    if (rFrom && rTo) {
      return dateIsBetween(moveInDate, rFrom, rTo);
    } else if (rFrom && !rTo) {
      return dateIsEqualOrAfter(moveInDate, rFrom);
    } else if (!rFrom && rTo) {
      return dateIsEqualOrBefore(moveInDate, rTo);
    }

    return false;
  });
};

export const getMinAvailableDate = availabilities => {
  const today = startOfDay(getDateAsUTC(new Date()));

  const foundRange = availabilities.find(range => {
    const rangeFrom = getDateAsUTC(range.from);
    return dateIsEqualOrAfter(rangeFrom, today);
  });

  return foundRange && foundRange.from ? foundRange.from : today;
};

export const isDateDisabledFactory = moveInDatesRanges => date => {
  const isInRange = isMoveInDateValid(date, moveInDatesRanges);

  return !isInRange;
};

export default {
  isMinStayValid,
  isMaxStayValid,
  isMoveInDateValid,
  getMinAvailableDate,
  isDateDisabledFactory
};
